import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../Icon';

const PlusIcon = ({ fill='#000', ...props }) => {
  return (
    <Icon viewBox="0 0 80 80" {...props}>
      <path
        fill={fill}
        // transform="translate(-1)"
        d="M73.338,30.3866667 L50.7073333,30.336 L50.758,7.70533333 C50.7673333,3.48133333 47.3193333,0.0186666667 43.0953333,0.00933333333 L39.0833333,-1.14900697e-15 C34.8606667,-0.00933333333 31.3966667,3.43866667 31.3873333,7.66266667 L31.3366667,30.2933333 L8.70466667,30.2426667 C4.482,30.232 1.01933333,33.68 1.00866667,37.904 L0.999333333,41.916 C0.99,46.14 4.438,49.604 8.662,49.6133333 L31.2926667,49.664 L31.242,72.2946667 C31.2326667,76.5186667 34.6806667,79.9813333 38.9046667,79.9906667 L42.918,80 C47.1406667,80.0093333 50.6033333,76.5613333 50.6126667,72.3373333 L50.6633333,49.708 L73.2953333,49.7573333 C77.518,49.768 80.9806667,46.32 80.9913333,42.096 L80.9993333,38.0826667 C81.01,33.8586667 77.562,30.396 73.338,30.3866667"
      />
    </Icon>
  );
};

PlusIcon.propTypes = {
  fill: PropTypes.string,
};

export default PlusIcon;
